// extracted by mini-css-extract-plugin
export const atlasGrotesk = "'AtlasGrotesk'";
export const bold = "700";
export const buttonList = "RadioButtonList__buttonList__QlN65";
export const buttonListItem = "RadioButtonList__buttonListItem__2IO-G";
export const error = "RadioButtonList__error__RkBxX font-faces__sansRegular__c8KXl font-faces__sans__uCf65";
export const errorFontSize = "var(--error-font-size)";
export const errorMarginTop = "var(--error-margin-top)";
export const headBgColorExternal = "var(--salt)";
export const headBgColorInternal = "var(--shade)";
export const headBgColorShrunkSidebar = "var(--slate)";
export const inline = "RadioButtonList__inline__OFxbJ";
export const inlineHeight = "var(--inline-height)";
export const label = "RadioButtonList__label__yVLT5";
export const left = "RadioButtonList__left__zTcVG";
export const medium = "500";
export const regular = "400";
export const sans = "'sans'";
export const semibold = "600";
export const serif = "'serif'";
export const wrap = "RadioButtonList__wrap__oiV9A";